import userApi from '../api/UserApi';
import { router } from '../index';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOADING = 'LOADING';
export const AUTHORIZED = 'AUTHORIZED';
export const SET_MESSAGE = 'SET_MESSAGE';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const CHECK_SESSION = 'CHECK_SESSION';

export const commonActions = {
    login: () => dispatch => {
        dispatch({ type: LOADING, value: true });
        userApi.login();
    },
    logout: () => () => {
        userApi.logout();
    },
    checkSession: () => dispatch => {
        userApi
            .checkSession()
            .then(response => {
                const type = response.isAuthorized === true
                    ? AUTHORIZED
                    : UNAUTHORIZED;

                dispatch({
                    type,
                    data: response,
                });
            });
    },
    setLoader: value => dispatch => {
        dispatch({ type: LOADING, value });
    },
    setMessage: value => dispatch => {
        dispatch({ type: SET_MESSAGE, value });
    },

    history: {
        accessForbidden: () => router.navigate('/clientapp/access-forbidden'),
        push: path => router.navigate(path),
        goBack: () => router.navigate(-1),
    }
}